import React, { useState } from 'react';
import { Button, Modal } from 'rsuite';
import { useTranslation } from 'react-i18next';
import { InfoButton } from '../../../../../common-client2/src/components';
import NotificationTags from './NotificationTags';
import './CustomTagsDisplay.scss';

function CustomTagsDisplay({ requestType }) {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'notifications' });
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <div className="ctd-container">
            <InfoButton
                onClick={() => setIsModalOpen(true)}
                text={t('customTagsButtonLabel')}
            />
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                dialogClassName="ctd-modal"
                style={{ zIndex: 1300 }}
                size="md"
                enforceFocus={false}
            >
                <Modal.Title>{t('customTagsButtonLabel')}</Modal.Title>
                <Modal.Body
                    className="modal-body"
                >
                    <NotificationTags requestType={requestType}/>
                </Modal.Body>
                <Modal.Footer >
                    <div className="modal-footer">
                        <Button
                            onClick={() => setIsModalOpen(false)}
                            appearance="primary"
                        >
                            {t('customTagsModalButtonLabel')}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default CustomTagsDisplay;
